module.exports = __webpack_public_path__ + "img/会议会诊管理.466ed7e3.png";